const socials = [
  {
    label: "GitHub",
    href: "https://github.com/stefanlatic",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"/>
      </svg>
    ),
  },
  {
    label: "LinkedIn",
    href: "https://linkedin.com/in/stefanlatic",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
  },
  {
    label: "Email",
    href: "mailto:stefanlatic2002@gmail.com",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
        <polyline points="22,6 12,13 2,6"/>
      </svg>
    ),
  },
];

const techStack = [
  "React", "Next.js", "Vue.js", "Node.js",
  "MongoDB", "Express.js", "TypeScript", "Tailwind CSS",
  "PostgreSQL", "REST APIs", "Git & GitHub", "Vercel",
];

const HeroSection = () => (
  <section id="home" className="relative min-h-screen bg-[#0d0e18] overflow-hidden">

    {/* Subtle grid background */}
    <div
      className="absolute inset-0 opacity-[0.03]"
      style={{
        backgroundImage:
          "linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)",
        backgroundSize: "60px 60px",
      }}
    />

    {/* Left vertical social bar — desktop only */}
    <div className="absolute left-6 top-1/2 -translate-y-1/2 hidden lg:flex flex-col items-center gap-5 z-10">
      {socials.map(({ label, href, icon }) => (
        <a
          key={label}
          href={href}
          target={href.startsWith("mailto") ? undefined : "_blank"}
          rel="noopener noreferrer"
          aria-label={label}
          className="text-gray-600 hover:text-[#f5c210] transition-colors"
        >
          {icon}
        </a>
      ))}
      <div className="w-px h-16 bg-gray-700 mt-2" />
    </div>

    {/* Main content */}
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 pt-20 pb-12 min-h-screen flex items-center">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 xl:gap-20 w-full items-center">

        {/* ── LEFT: Name + Photo ── */}
        <div className="relative flex flex-col">
          <h1 className="font-IBM font-bold text-white leading-none">
            <span className="block text-6xl sm:text-7xl md:text-8xl xl:text-9xl">Stefan</span>
            <span className="block text-6xl sm:text-7xl md:text-8xl xl:text-9xl">Latić.</span>
          </h1>
          <div className="w-14 h-1 bg-[#f5c210] my-5" />

          {/* Mobile social links */}
          <div className="flex items-center gap-5 mb-8 lg:hidden">
            {socials.map(({ label, href, icon }) => (
              <a
                key={label}
                href={href}
                target={href.startsWith("mailto") ? undefined : "_blank"}
                rel="noopener noreferrer"
                aria-label={label}
                className="text-gray-500 hover:text-[#f5c210] transition-colors"
              >
                {icon}
              </a>
            ))}
          </div>

          {/* Photo */}
          <div className="relative mt-2">
            {/* Yellow glow behind photo */}
            <div className="absolute bottom-10 left-1/4 w-48 h-48 bg-[#f5c210]/10 rounded-full blur-3xl pointer-events-none" />

            <img
              src="/mypicture1.png"
              alt="Stefan Latić"
              className="relative w-64 sm:w-80 md:w-96 lg:w-full max-w-sm mx-auto lg:mx-0 object-contain"
              style={{ filter: "drop-shadow(0 20px 60px rgba(0,0,0,0.6))" }}
            />

            {/* Edge-fade overlays — blend white bg edges into dark background */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#0d0e18] via-transparent to-[#0d0e18] pointer-events-none" />
            <div className="absolute inset-0 bg-gradient-to-b from-[#0d0e18] via-transparent to-[#0d0e18] pointer-events-none" />
            <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#0d0e18] to-transparent pointer-events-none" />
          </div>
        </div>

        {/* ── RIGHT: Introduction ── */}
        <div className="lg:pl-4">
          <p className="text-[#f5c210] text-xs tracking-[0.2em] uppercase font-IBM mb-5">
            — Introduction
          </p>
          <h2 className="font-IBM font-semibold text-white text-3xl sm:text-4xl xl:text-5xl leading-tight mb-6">
            Full Stack Developer,<br />based in Serbia.
          </h2>
          <p className="text-gray-400 font-IBM text-base leading-relaxed mb-8 max-w-md">
            I build complete digital products — from pixel-perfect frontends to
            robust, scalable backends. Started my career operating CNC machines;
            today I craft fast, modern web applications with the same precision
            and discipline that manufacturing demands.
          </p>

          <button
            onClick={() => document.getElementById("works")?.scrollIntoView({ behavior: "smooth" })}
            className="inline-flex items-center gap-3 text-[#f5c210] font-IBM font-medium group"
          >
            My work
            <span className="text-xl transition-transform group-hover:translate-x-2">→</span>
          </button>

          {/* Tech stack */}
          <div className="mt-10 pt-8 border-t border-[#1e2030]">
            <p className="text-gray-600 text-xs tracking-widest uppercase font-IBM mb-4">
              Tech Stack
            </p>
            <div className="flex flex-wrap gap-2">
              {techStack.map((tech) => (
                <span
                  key={tech}
                  className="text-xs font-IBM text-gray-400 border border-[#1e2030] rounded-full px-3 py-1 hover:border-[#f5c210]/50 hover:text-white transition-colors"
                >
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Scroll arrow */}
    <button
      onClick={() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })}
      aria-label="Scroll down"
      className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-gray-600 hover:text-[#f5c210] transition-colors"
    >
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </button>
  </section>
);

export default HeroSection;
